import { formatDate, parseAmount } from "../services/utils";
import useApiService from "./useApiService";

const usePayments = () => {
  const { get, put } = useApiService();

  const fetchReceivedPayments = async () => {
    const paymentMethodStrings = {
      bank_transfer: "Bank Transfer",
      cheque: "Cheque",
      cash: "Cash",
    };
    try {
      const response = await get("/api/credits/payments");
      if (response.status && response.data) {
        return {
          payments: response.data.map((payment) => ({
            ...payment,
            amount: payment.amount,
            due_date: payment.due_date ? formatDate(payment.due_date) : null,
            date_received: payment.date_received ? formatDate(payment.date_received) : null,
            payment_proof_url: payment.payment_proof?.url,
            payment_method: payment.payment_method
              ? payment.payment_method in paymentMethodStrings
                ? paymentMethodStrings[payment.payment_method]
                : `${payment.payment_method}`.toUpperCase()
              : null,
            reference_number: payment.reference_number && payment.reference_number?.toUpperCase(),
          })),
        };
      } else {
        throw new Error("Unable to fetch payments");
      }
    } catch (error) {
      return { error };
    }
  };

  const fetchCommissionPayments = async () => {
    try {
      const paymentMethodStrings = {
        bank_transfer: "Bank Transfer",
        cheque: "Cheque",
        cash: "Cash",
      };
      const response = await get("/api/credits/commission");
      if (response.status && response.data) {
        return {
          payments: response.data.map((payment) => ({
            ...payment,
            amount: payment.amount,
            payment_method: payment.payment_method
              ? payment.payment_method in paymentMethodStrings
                ? paymentMethodStrings[payment.payment_method]
                : `${payment.payment_method}`.toUpperCase()
              : null,
            reference_number: payment.reference_number && payment.reference_number?.toUpperCase(),
          })),
        };
      } else {
        throw new Error("Unable to fetch payments");
      }
    } catch (error) {
      return { error };
    }
  };

  const fetchDebits = async () => {
    const paymentMethodStrings = {
      bank_transfer: "Bank Transfer",
      cheque: "Cheque",
      cash: "Cash",
    };
    try {
      const response = await get("/api/debits");
      if (response.status && response.data) {
        return {
          payments: response.data.map((payment) => ({
            ...payment,
            id: payment.payment_id,
            commission: parseAmount(payment.commission),
            payment_method: payment.payment_method
              ? payment.payment_method in paymentMethodStrings
                ? paymentMethodStrings[payment.payment_method]
                : `${payment.payment_method}`.toUpperCase()
              : null,
            reference_number: payment.reference_number && payment.reference_number?.toUpperCase(),
          })),
        };
      } else {
        throw new Error("Unable to fetch payments");
      }
    } catch (error) {
      return { error };
    }
  };

  const updatePaymentProof = async (id, data) => {
    try {
      const response = await put(`/api/debits/${id}`, data);
      if (response.status) return { success: "Payment proof updated successfully." };
      else throw new Error("Error updating payment proof");
    } catch (error) {
      return { error };
    }
  };

  const updatePaymentStatus = async (id, data) => {
    try {
      const response = await put(`/api/payment/${id}`, data);
      if (response.status) {
        return { success: "Updated successfully" };
      } else {
        throw new Error("Failed to update");
      }
    } catch (error) {
      return { error };
    }
  };

  return { fetchReceivedPayments, fetchCommissionPayments, fetchDebits, updatePaymentProof, updatePaymentStatus };
};

export default usePayments;
